import React from "react";
import { useState, useEffect } from "react";
import {
   Pie,
   PieChart,
   Cell,
   ComposedChart,
   Bar,
   Line,
   BarChart,
   AreaChart,
   Area,
   XAxis,
   YAxis,
   CartesianGrid,
   Tooltip,
   ReferenceLine,
   Legend,
   ResponsiveContainer,
   LabelList,
} from "recharts";

export function CustomTooltip({ active, payload, label, userObject }) {
   if (!active || !payload || !payload.length) return null;

   return (
      <div style={{ background: "#fff", border: "1px solid #ccc", padding: 10 }}>
         <p>
            <strong>Monat: {label}</strong>
         </p>
         {payload.map((entry, index) => {
            if (entry.value > 5)
               return (
                  <p
                     key={index}
                     style={{
                        margin: 0,
                        ...(userObject[entry.dataKey]
                           ? { color: entry?.color ?? "#f0f" }
                           : { color: "#000", fontWeight: 700 }),
                     }}
                  >
                     {userObject[entry.dataKey]?.Name ?? entry.dataKey}: {entry.value}
                  </p>
               );
         })}
      </div>
   );
}

export function CustomTermineLabel(props) {
   const { x, y } = props;
   const paddingX = 10;
   const paddingY = 6;
   const textWidth = 90; // grob abschätzen, je nach Textlänge anpassen
   const textHeight = 24;

   return (
      <g
         transform={`translate(${x}, ${y}) rotate(-90)`}
         // onClick={() => setSortTerminResultKey("Termine")}
         style={{ cursor: "pointer" }}
      >
         <rect
            x={-textWidth / 2 - paddingX}
            y={-textHeight / 2 - paddingY}
            width={textWidth + paddingX * 2}
            height={textHeight + paddingY * 2}
            rx={8}
            ry={8}
            fill="#1a1a1a"
         />

         <text textAnchor="middle" dominantBaseline="middle" fontWeight={500} fontSize={20} fill={"#fff"}>
            Termine
         </text>
      </g>
   );
}
